import React, { useEffect, useMemo, useState } from 'react';
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import ReactStars from "react-rating-stars-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from '../../../../hooks/useConfiguration';
import useSessionStorage from '../../../../hooks/useSessionStorage';
import Footer from '../../../common/Footer';
import GridTable from '../../../common/GridTable';
import Header from '../../../common/Header';
import { headerInfoSelector } from '../../../common/Header/selector';
import Loader from '../../../common/Loader';
import Sidebar from '../../../common/Sidebar';
import DropDown from '../../../common/TextField/dropDown';
import * as Toasts from '../../../common/Toastify';
import { getCandidateSearchDetail, loadMasterData, resetParamVal, updateParams, updateStatus } from './action';
import column from './column.json';
import { candidateSearchSelector } from './selector';

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const { masterData, params, data } = useSelector(candidateSearchSelector);
    const { headerData } = useSelector(headerInfoSelector);
    const location = useLocation();
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem("login");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form, setForm] = useState(params);
    const [searchErrors, setSearchErrors] = useState({});
    const { searchText } = location.state || {};
    const [childarg, setChildarg] = useState({});
    const [tableData, setTableData] = useState(JSON.parse(JSON.stringify(data)));
    const [skipPageReset, setSkipPageReset] = useState(false);
    const [rowData, setRowData] = useState({});
    const [count, setCount] = useState(0);
    const [showTable, setShowTable] = useState(true);

    const hiddenColumns = ['hoursWorked', 'shiftsCompleted', 'phone', 'email', 'city', 'state', 'zipcode'];

    useEffect(() => {
        document.title = "Candidate Search";
    }, []);

    useEffect(() => {
        setSkipPageReset(false);
    }, [tableData]);

    useEffect(() => {
        const newData = JSON.parse(JSON.stringify(data));
        setTableData(newData);
    }, [data]);

    useEffect(() => {
        if (config.baseUrl) {
            if (!login) {
                navigate("/");
            } else {
                if (!searchText) {
                    dispatch(loadMasterData(`${config.baseUrl}`, login.employerUniqueId))
                    // const newparams = {
                    //     ...params,
                    //     'employerUniqueId': login.employerUniqueId,
                    // }
                    // dispatch(loadMasterData(`${config.baseUrl}`, login.employerUniqueId)).then(() => {
                    //     dispatch(getCandidateSearchDetail({
                    //         url: `${config.baseUrl}/Employers/search-new-candidates`, params: newparams
                    //     }));
                    // })
                } else {
                    const newparams = {
                        ...params,
                        'employerUniqueId': login.employerUniqueId,
                        'SearchText': searchText,
                    }
                    dispatch(getCandidateSearchDetail({
                        url: `${config.baseUrl}/Employers/search-new-candidates`, params: newparams
                    }));
                    window.history.replaceState({}, document.title);
                }
            }
        }
    }, [config]);

    useEffect(() => {
        // console.log(form);
        const newparams = {
            ...form,
            'employerUniqueId': login.employerUniqueId,
        }
        dispatch(updateParams(newparams));
    }, [form]);

    useEffect(() => {
        setForm({
            ...params,
            'SearchText': headerData.SearchText,
        });

        const newparams = {
            ...params,
            'SearchText': headerData.SearchText,
        }
        if (config.baseUrl) {
            dispatch(getCandidateSearchDetail({
                url: `${config.baseUrl}/Employers/search-new-candidates`, params: newparams
            }));
        }

    }, [headerData])

    const clearFilter = () => {
        setSearchErrors({});
        setForm({
            "page": 0,
            "pageSize": 0,
            "sortOrder": "",
            "sortColumn": "",
            "distance": "",
            "locationId": "",
            'employerUniqueId': login.employerUniqueId,
            "status": [],
            "SearchText": "",
            "isSearchWithCrieteria": true,
            "positions": [],
            "certifications": [],
            "specialities": [],
            "emrehrSystem": [],
            "shifts": [],
            "education": [],
            "covid19Vaccinated": [],
            "jobTypeid": 0
        })
        // dispatch(resetParamVal()).then(() => {
        //     setTimeout(() => {
        //         const newparams = {
        //             "page": 0,
        //             "pageSize": 0,
        //             "sortOrder": "",
        //             "sortColumn": "",
        //             "distance": "",
        //             "locationId": "",
        //             'employerUniqueId': login.employerUniqueId,
        //             "status": [],
        //             "SearchText": "",
        //             "isSearchWithCrieteria": true,
        //             "positions": [],
        //             "certifications": [],
        //             "specialities": [],
        //             "emrehrSystem": [],
        //             "shifts": [],
        //             "education": [],
        //             "covid19Vaccinated": [],
        //             "jobTypeid": 0
        //         };
        //         dispatch(getCandidateSearchDetail({
        //             url: `${config.baseUrl}/Employers/search-new-candidates`, params: newparams
        //         }));
        //     }, 800)
        // });
    }

    const validate = () => {
        if (params.locationId && params.distance) {
            setSearchErrors({});
            return true;
        } else if (!params.locationId && !params.distance) {
            const obj = {
                'distance': ['This field is required'],
                'locationId': ['This field is required']
            };

            setSearchErrors(obj);
            return false;
        } else if (!params.locationId && params.distance) {
            setSearchErrors({ 'locationId': ['This field is required'] }, { 'distance': [] });
            return false;
        } else if (params.locationId && !params.distance) {
            setSearchErrors({ 'distance': ['This field is required'] }, { 'distance': [] });
        }
    }

    const filterTable = () => {
        if (validate()) {
            //setShowTable(!showTable)
            dispatch(getCandidateSearchDetail({
                url: `${config.baseUrl}/Employers/search-new-candidates`, params: params
            }));
        }
    }

    const updateDropVal = (target) => {
        // console.log(target.name, target.value);
        setForm({
            ...params,
            [target.name]: target.value
        });
    }

    const updateStstusDropVal = (target) => {
        if (target.action === 'add') {
            setForm({
                ...params,
                [target.name]: params.status.length ? [...params.status, target.value] : [target.value]
            });
        } else if (target.action === 'remove') {
            const newData = params.status.filter(item => item.id !== target.value.id);
            setForm({
                ...params,
                [target.name]: [...newData]
            });
        }
    }

    const updateVal = (target) => {
        if (target.validity.valid) {
            setForm({
                ...params,
                [target.name]: target.value
            });
        }
    }

    useEffect(() => {
        if (Object.keys(rowData).length) {
            if (!form.locationId) {
                Toasts.info('Please Select Location Name On The Search Filter');
            } else {
                navigate("/candidatesearchview",
                    {
                        state: {
                            userData: rowData,
                            loctionId: form.locationId
                        }
                    })
            }
        }

    }, [count])


    const RoutingToCandidateView = (row) => {
        setRowData(row);
        setCount((old) => old + 1);
    }

    useEffect(() => {
        if (Object.keys(childarg).length) {
            if (!form.locationId) {
                Toasts.info('Please Select Location Name On The Search Filter');
            } else {
                if (parseInt(childarg.id) === 99) {
                    Toasts.info('Please Select Valid status other than New');
                } else {
                    const newData = tableData.map((item) => {
                        if (item.candidateId === childarg.row.candidateId) {
                            item.statusId = parseInt(childarg.id);
                        }
                        return item;
                    });
                    setTableData(newData);
                    setSkipPageReset(true);
                    const requestResponsce = {
                        candidateUniqueId: childarg.row.candidateUniqueId,
                        employerUniqueId: login.employerUniqueId,
                        locationId: form.locationId,
                        appUserUniqueId: login.appUserUniqueId,
                        candidateStatusForEmployer: parseInt(childarg.id),
                        sourceWebsite: window.location.hostname
                    };
                    dispatch(updateStatus({
                        url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`, params: requestResponsce
                    }));
                }
            }
        }
    }, [childarg])

    const changeheStatus = (id, row) => {
        setChildarg({ id, row });
    }

    const createStar = (count) => {
        let color = '';
        const val = count;
        if (val >= 4) {
            color = 'green';
        } else if (val >= 3) {
            color = 'yellow';
        } else if (val < 3 && val >= 0) {
            color = 'red ';
        } else if (val <= 0) {
            color = 'black ';
        }
        const star = {
            size: 15,
            count: 5,
            value: count,
            edit: false,
            color: color,
            activeColor: color,
            a11y: true,
            isHalf: true,
            emptyIcon: <i className="fa fa-star-o" />,
            halfIcon: <i className="fa fa-star-half-o" />,
            filledIcon: <i className="fa fa-star" />
        }
        return <ReactStars {...star} />
    }

    const Createoverlays = (data, arrayData) => {
        const renderTooltip = (props) => (
            <Tooltip id="button-tooltip" {...props}>
                {arrayData.map(item => <div>{item.name}</div>)}
            </Tooltip>
        );
        return (<>
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
            >
                <span variant="success">{data}</span>
            </OverlayTrigger>
        </>)
    }

    const CreateoverlaysAll = (arrayData) => {

        const statusColorMap = {
            1: 'green',
            2: 'red',
            0: 'black'
        }
        const popover = (
            <Popover id="popover-basic">
                <Popover.Body>
                    {arrayData.map(item => <div style={{ color: statusColorMap[item.isExists] }}>{item.name}</div>)}
                </Popover.Body>
            </Popover>
        );


        return (<>
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={popover}
            >
                <span variant="success">{arrayData.slice(0).map(item => <div className='criteria' style={{ color: statusColorMap[item.isExists] }}>{item.name}</div>)}</span>
            </OverlayTrigger>
        </>)
    }

    const newColumn = useMemo(() => [
        {
            Header: 'View',
            accessor: "view",
            id: 'view',
            disableSortBy: true,
            Cell: ({ row }) => {
                return (

                    <button id="bAcep" type="button" className="btn  btn-sm" title="View Contacts"
                        onClick={() => RoutingToCandidateView(row.original)}>
                        <span className="fa fa-eye fa-lg"> </span> {row.original.ovCandidateFlag}
                    </button>
                )
            },

        },
        {
            "Header": "Status",
            "accessor": "status",
            id: 'status',
            Cell: ({ row }) => {
                return (
                    <select
                        value={row.original.statusId}
                        name="status"
                        onChange={e => { changeheStatus(e.target.value, row.original) }}
                    >
                        {masterData.newStatusList.map((item) => (
                            <option key={item.id} value={item.id}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                )
            }

        },
        {
            Header: 'Ratings',
            accessor: "ratings",
            id: 'ratings',
            disableSortBy: true,
            Cell: ({ row }) => {
                return row.original.ratings ? createStar(Math.round(row.original.ratings)) : createStar(0)
            }
        },
        {
            "Header": "Distance",
            "accessor": "distance"
        },
        {
            "Header": "Name",
            "accessor": "name"
        },
        {
            "Header": "Hours Worked",
            "accessor": "hoursWorked"
        },
        {
            "Header": "Shifts Completed",
            "accessor": "shiftsCompleted"
        },
        {
            "Header": "Phone",
            "accessor": "phone"
        },
        {
            "Header": "Email",
            "accessor": "email"
        },
        {
            "Header": "City",
            "accessor": "city"
        },
        {
            "Header": "State",
            "accessor": "state"
        },
        {
            "Header": "Zip",
            "accessor": "zipcode"
        },
        {
            Header: 'Nursing Level',
            accessor: "jobCategoryName",
            id: 'jobCategoryName',
            Cell: ({ row }) => {
                return row.original.jobCategory?.length > 0 ? CreateoverlaysAll(row.original.jobCategory) : ''
            }
        },
        {
            Header: 'Certifications',
            accessor: "certificationsName",
            id: 'certificationsName',
            Cell: ({ row }) => {
                return row.original.certificationsList?.length > 0 ? CreateoverlaysAll(row.original.certificationsList) : ''
            }
        },
        {
            Header: 'Specialties',
            accessor: "specialtyName",
            id: 'specialtyName',
            Cell: ({ row }) => {
                return row.original.specialtyList?.length > 0 ? CreateoverlaysAll(row.original.specialtyList) : ''
            }
        },
        {
            Header: 'Education',
            accessor: "levelofEducation",
            id: 'levelofEducation',
        },
        {
            Header: 'EMR/EHR',
            accessor: "emrehrSystemName",
            id: 'emrehrSystemName',
            Cell: ({ row }) => {
                return row.original.emrehrSystemList?.length > 0 ? CreateoverlaysAll(row.original.emrehrSystemList) : ''

            }
        },
        {
            Header: 'shift',
            accessor: "preferredShiftName",
            id: 'preferredShiftName',
            Cell: ({ row }) => {
                return row.original.preferredShiftList?.length > 0 ? CreateoverlaysAll(row.original.preferredShiftList) : ''
            }
        },
        {
            Header: 'Vaccine',
            accessor: "covid19Vaccinated",
            id: 'covid19Vaccinated'
        },
        {
            Header: 'Message',
            accessor: "message",
            id: 'message',
        }
    ], [masterData.newStatusList]);

    return (
        <div className="page main-margin">
            <Loader />
            <Header />
            <Sidebar />
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">
                                <h1 className="page-title">New Candidate Search</h1>
                                <div>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                                        <li className="breadcrumb-item active" aria-current="page">New Candidate Search</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Candidate Search Filter</h3>
                                            <div className="card-options">
                                                <a href="javascript:void(0)" className="card-options-collapse" data-bs-toggle="card-collapse"><i className="fe fe-chevron-up"></i></a>

                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className='col-lg-3 col-md-3'>
                                                    <div className="form-group">
                                                        <label htmlFor={'Location Name'}>Location Name</label>
                                                        <select className="form-select"
                                                            value={params.locationId}
                                                            name="locationId"
                                                            onChange={e => {
                                                                updateDropVal(e.target)
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {masterData.locationList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {searchErrors['locationId'] && searchErrors['locationId'].map(error => (<div className="invalid-input">{error}</div>))}
                                                    </div>
                                                </div>
                                                <div className='col-lg-2 col-md-2'>
                                                    <div className="form-group">
                                                        <label htmlFor={'distance'}>Distance</label>
                                                        {/* <input type="text" pattern="[0-9]*"
                                                            onChange={(e) => { updateVal(e.target) }} value={params.distance}
                                                            placeholder="Distance Radius Miles"
                                                            name='distance'
                                                            className="form-control"
                                                        /> */}
                                                        <select className="form-select"
                                                            value={params.distance}
                                                            name="distance"
                                                            onChange={e => {
                                                                updateDropVal(e.target)
                                                            }}
                                                        >
                                                            <option value="">Select</option>
                                                            {masterData.travelDistanceList.map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {searchErrors['distance'] && searchErrors['distance'].map(error => (<div className="invalid-input">{error}</div>))}
                                                    </div>
                                                </div>
                                                <div className='col-lg-4 col-md-4'>
                                                    <div className="form-group">
                                                        <DropDown name={"status"} label={'Status'}
                                                            placeholder={"Select Location Name"} updateValue={updateStstusDropVal}
                                                            value={params.status}
                                                            options={masterData.statusList} showArrow={true} isObject={true} multiple={true}
                                                            errors={''} />
                                                    </div>
                                                </div>
                                                <div className='col-lg-3 col-md-3'>
                                                    <div className="form-group">
                                                        <label ></label>
                                                        <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end"><div className="btn-group me-2 sw-btn-group" role="group">
                                                            <button className="btn btn-primary sw-btn-next" type="button" onClick={filterTable}>Search</button></div>
                                                            <div className="btn-group mr-2 sw-btn-group-extra" role="group">
                                                                <button className="btn btn-outline-primary" onClick={clearFilter}>Clear</button></div></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    {showTable && <GridTable columns={newColumn} data={tableData}
                                        skipPageReset={skipPageReset} updateData={changeheStatus}
                                        hiddenColumns={hiddenColumns} title={'New Candidate Search'}
                                    />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>)
}
